import PaymentNoteDocuments from './PaymentNoteDocuments';

export default PaymentNoteDocuments;
